export const ANALYTICS_TIMEFRAME = Object.freeze({
    LAST_SEVEN: "last-seven",
    LAST_THIRTY: "last-thirty",
    ALL_TIME: "all-time",
  });
  
export const TOPIC_LIST = [
    {
      "topicId": -1,
      "topicName": "All"
    },
    {
      "topicId": 1,
      "topicName": "Arts & Culture"
    },
    {
      "topicId": 2,
      "topicName": "Geopolitics"
    },
    {
      "topicId": 3,
      "topicName": "Global Economy"
    },
    {
      "topicId": 4,
      "topicName": "Global Security"
    },
    {
      "topicId": 5,
      "topicName": "Science"
    },
    {
      "topicId": 6,
      "topicName": "Sports"
    },
    {
      "topicId": 7,
      "topicName": "Technology"
    },
    {
      "topicId": 8,
      "topicName": "US Economy"
    },
    {
      "topicId": 9,
      "topicName": "US Politics"
    },
    {
      "topicId": 10,
      "topicName": "Wildcard"
    },
    {
      "topicId": 11,
      "topicName": "Other"
    }
  ];

export const METRIC_LIST = [
  {
    "metricId": 1,
    "metricName": "Overall Rank",
    "description": "Rank among publishers"
  },
  {
    "metricId": 2,
    "metricName": "First Click",
    "description": "How many users clicked first"
  },
  {
    "metricId": 3,
    "metricName": "New Readers",
    "description": "How many new readers"
  },
  {
    "metricId": 4,
    "metricName": "Retention",
    "description": "How many new retained"
  },
  {
    "metricId": 5,
    "metricName": "Unique Visitors",
    "description": "Number of unique visitors"
  },
  {
    "metricId": 6,
    "metricName": "Total Visits",
    "description": "Total number of visits for a publisher"
  },
  {
    "metricId": 7,
    "metricName": "New Bookmarks",
    "description": "How many new bookmarks"
  }
]

export const METRIC_DESCRIPTIONS = {
  'Total Visits': 'The total number of user article clicks across all app areas.',
  'Unique Visitors': 'Count of distinct individual users who visited this publisher\'s content, excluding repeat visits from the same user',
  'Total Impressions': 'Total number of times this publisher\'s content appeared in search and pulse results.',
  'Overall Rank': 'Publisher\'s performance ranking compared to all other publishers based on visits',
  'Click Through Rate': 'Percentage of search impressions that resulted in actual visits (Total Visits ÷ Total Search Impressions × 100)',
  'First Click': 'Percentage of users who clicked on this publisher\'s content as their first interaction during their search',
  'New Readers': 'Count of first-time visitors who had never previously engaged with this publisher\'s content',
  'Retention': 'Percentage of users who returned to read more content from this publisher after their initial visit',
  'New Bookmarks': 'Total count of new bookmarks created by users for this publisher\'s content.'
};